import { createLazyAddressFormatter } from "@authe/ui-core";

// No web3 root import: this subpath contains only the checksum utility. The
// shared service loads it after the first EVM address mounts and the UI paints.
export const addressChecksum = createLazyAddressFormatter(() =>
  import("@authe/web3/address").then(module => module.checksumEvmAddress),
);
